import React from "react";

export default function TabMenu({
  items = [],
  activeTab,
  onTabChange,
  containerStyle = {},
  tabStyle = {},
  activeTabStyle = {},
  labelStyle = {},
}) {
  const activeContent = items.find((item) => item.value === activeTab)?.content;

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: 16,
      }}
    >
      <div
        style={{
          display: "flex",
          gap: 8,
          padding: 4,
          borderRadius: 8,
          backgroundColor: "#F6F6F6",
          alignItems: "center",
          ...containerStyle,
        }}
      >
        {items.map((item, index) => {
          const isActive = item.value === activeTab;
          return (
            <div
              key={index}
              style={{
                padding: "6px 8px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: 6,
                boxShadow: isActive ? "0 4px 8px 0 rgba(16, 24, 40, 0.10)" : "",
                backgroundColor: isActive ? "#FFFFFF" : "transparent",
                width: "100%",
                cursor: "pointer",
                ...tabStyle,
                ...(isActive ? activeTabStyle : {}),
              }}
              onClick={() => onTabChange(item.value)}
            >
              <p
                style={{
                  fontWeight: 500,
                  margin: 0,
                  fontSize: 12,
                  ...labelStyle,
                }}
              >
                {item.label}
              </p>
            </div>
          );
        })}
      </div>

      {activeContent}
    </div>
  );
}
